import { FC } from 'react'
import { animated, useSpring } from 'react-spring'

const FadeAnimationDiv: FC = ({ children, ...props }) => {
    const fade = useSpring({ from: { opacity: 0 }, opacity: 1 })

    return (
        <animated.div style={fade} {...props}>
            {children}
        </animated.div>
    )
}

export default FadeAnimationDiv
